module.exports = __webpack_public_path__ + "img/usdc2OLD.641e3454.svg";